/** The new design's spring for a move that settles with no overshoot. */
export const SPRING = { type: 'spring', visualDuration: 0.3, bounce: 0 } as const;

/**
 * Motion's features, layout animations included, for a `LazyMotion` of a surface rendered above the layouts', as a
 * modal opened with `useModal` is. The dynamic import is what keeps them in a chunk of their own.
 */
export const loadMotionFeatures = () =>
    import('layout/NewDesignLayout/motionFeatures').then((module) => module.default);

const GONE = { opacity: 0, scale: 0.95 };
const FADED = { opacity: 0 };
const SHOWN = { opacity: 1, scale: 1 };
/** `--duration-quick`. */
const FADE = { duration: 0.15, ease: 'easeOut' } as const;

/**
 * A step of a dialog or popover of steps, keyed in `AnimatePresence initial={false} mode="popLayout"`: it comes out of
 * a fade and a 0.95 scale and leaves into them, on `SPRING`. Under reduced motion it only fades.
 */
export const stepMotion = (reduced: boolean) => ({
    initial: reduced ? FADED : GONE,
    animate: SHOWN,
    exit: reduced ? FADED : GONE,
    transition: reduced ? FADE : SPRING,
});
